import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { AddFavListResponse } from "./createFavouriteList"

export interface UpdateFavoriteListParams {
  favouriteListId: string
  favouriteListName: string
  propertyId?: string | null
  previewsFavouriteListId?: string | number
  priceDropAlertId?: string | number
}

export interface UpdateFavoriteListRequest extends Partial<AxiosRequestConfig> {
  params: UpdateFavoriteListParams
}

export interface UpdateFavoriteListResponseData extends ResponseData {
  data: AddFavListResponse
}
export interface UpdateFavoriteListResponse extends AxiosResponse {
  data: UpdateFavoriteListResponseData
}

//
export function updateFavoriteListApi(
  { params }: UpdateFavoriteListRequest,
  axiosInstance: AxiosInstance,
): Promise<UpdateFavoriteListResponse> {
  const url = `/user/favouritelist/updatefavouriteList`
  return axiosInstance({
    data: params,
    method: "put",
    url,
  }) as Promise<UpdateFavoriteListResponse>
}
